<template>
    <div class="row">
        <div class="form-group col-md-6">
            <label>{{ $t('hall.hall') }}</label>
            <input type="text" class="form-control" readonly
                   v-model="hall.name">
        </div>
        <div class="form-group col-md-6">
            <label>{{ $t('hall.capacity') }}</label>
            <input type="text" class="form-control" readonly
                   v-model="hall.capacity">
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            hall: Object
        }
    }
</script>

<style scoped>
     input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
